import { defineSlotRecipe } from '@chakra-ui/react';

export const toastSlotRecipe = defineSlotRecipe({
  slots: ['root'],
  variants: {
    variant: {
      'left-accent': {
        root: {
          borderLeft: '4px solid',
          borderColor: 'colorPalette.solid',
          bg: 'colorPalette.contrast',
          '&[data-type=success]': {
            bg: 'success.subtle',
            color: 'black',
            borderColor: 'success.solid',
            _icon: {
              color: 'success.solid',
            },
          },
          '&[data-type=warning]': {
            bg: 'warning.subtle',
            color: 'black',
            borderColor: 'warning.solid',
            _icon: {
              color: 'warning.solid',
            },
          },
          '&[data-type=error]': {
            bg: 'danger.subtle',
            color: 'black',
            borderColor: 'danger.solid',
            _icon: {
              color: 'danger.solid',
            },
          },
          '&[data-type=loading]': {
            bg: 'info.subtle',
            color: 'black',
            '--toast-trigger-bg': '{white/10}',
            '--toast-border-color': '{white/40}',
            borderColor: 'info.solid',
            _icon: {
              color: 'info.solid',
            },
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: 'left-accent',
  },
});

export default toastSlotRecipe;
